import { Controller } from "@hotwired/stimulus";

/**
 * Accessible Modal Dialogs
 * @see dialog.twig
 */
export class DialogController extends Controller {
  static values = {
    id: String,
  };

  static targets = ["dialogContainer"];

  static dialog = null;

  /**
   * @type {NodeListOf<HTMLElement>}
   */
  static triggers = null;

  connect() {
    console.log("Connect dialog controller");
    import("./dialog-library.js").then(({ A11yDialog }) => {
      this.dialog = new A11yDialog(this.dialogContainerTarget);

      this.initEventHandlers();
    });
  }

  initEventHandlers() {
    this.dialog.on("show", this.onShow);
    this.dialog.on("hide", this.onHide);
    this.dialog.on("destroy", this.onDestroy);
    this.dialog.on("create", this.onCreate);
  }

  show() {
    this.dialog.show();
  }

  hide() {
    this.dialog.hide();
  }

  onShow(dialogEl, event) {
    document.body.style.position = "fixed";
    document.body.style.top = `-${window.scrollY}px`;
  }

  onHide(dialogEl, event) {
    const scrollY = document.body.style.top;
    document.body.style.position = "";
    document.body.style.top = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
  }

  onDestroy(dialogEl) {}

  onCreate(dialogEl) {}

  /**
   * Register controller as "dialog"
   * @param {import('stimulus').Application} application
   */
  static register(application) {
    application.register("dialog", this);
  }
}
